import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { DeliveryChecklistForm } from '../components/tenants/DeliveryChecklistForm';

export const DeliveryInspectionForm: React.FC = () => {
  const { inspectionId } = useParams<{ inspectionId: string }>();
  const navigate = useNavigate();
  const { user } = useAuth();

  const { data: inspection, isLoading } = useQuery({
    queryKey: ['delivery-inspection-by-id', inspectionId],
    queryFn: () => api.getDeliveryInspectionById(inspectionId!),
    enabled: !!inspectionId,
  });

  const canComplete = useMemo(() => {
    if (!inspection || !user) return false;
    return inspection.assignedUserId === user.id && inspection.status !== 'completed';
  }, [inspection, user]);

  if (isLoading) {
    return <div className="py-12 text-center text-gray-500">Cargando inspección...</div>;
  }

  if (!inspection) {
    return <div className="py-12 text-center text-gray-500">Inspección no encontrada.</div>;
  }

  if (!canComplete) {
    return (
      <div className="max-w-3xl mx-auto py-8 space-y-4">
        <Card title="Inspección de entrega">
          <p className="text-sm text-gray-600">
            Esta inspección no está asignada a tu usuario o ya fue completada.
          </p>
          <div className="mt-3">
            <Button type="button" variant="secondary" onClick={() => navigate('/maintenance')}>
              Volver a mantenimiento
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto py-6 space-y-6">
      <Card title="Formulario de inspección de entrega">
        <p className="text-sm text-gray-600">
          Técnico asignado: <strong>{inspection.assignedUser?.name}</strong>
        </p>
      </Card>

      <DeliveryChecklistForm
        inspectionId={inspectionId!}
        onCancel={() => navigate('/maintenance')}
        onCompleted={() => setTimeout(() => navigate('/delivery-inspections'), 700)}
      />
    </div>
  );
};
